module.exports = __webpack_public_path__ + "img/copypaste.ed04681b.svg";